module.exports = __webpack_public_path__ + "img/open.a8f52279.png";